import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createSlots as _createSlots, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { name: "form" }
const _hoisted_4 = { class: "contain row" }
const _hoisted_5 = {
  key: 1,
  class: "page-container card col-md-8"
}
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "col-md-12 p-4" }
const _hoisted_8 = { class: "row mb-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Journal ID:")
], -1)
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "row mb-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Date:")
], -1)
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "row mb-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Entity:")
], -1)
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_18 = { class: "col-md-3" }
const _hoisted_19 = { class: "col-md-9" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "d-flex align-items-center col-md-12" }
const _hoisted_22 = { class: "col-md-3" }
const _hoisted_23 = { class: "col-md-9" }
const _hoisted_24 = { class: "row mb-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Description:")
], -1)
const _hoisted_26 = { class: "col-md-9" }
const _hoisted_27 = { class: "row mb-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Remarks:")
], -1)
const _hoisted_29 = { class: "col-md-9" }
const _hoisted_30 = { class: "row mb-1" }
const _hoisted_31 = { class: "row mb-2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Accounts:")
], -1)
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = {
  key: 0,
  class: "row"
}
const _hoisted_35 = { class: "col-md-2" }
const _hoisted_36 = { class: "col-md-10" }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-md-2" }
const _hoisted_40 = { class: "col-md-10" }
const _hoisted_41 = { class: "d-flex col-md-3" }
const _hoisted_42 = { class: "row mb-2" }
const _hoisted_43 = {
  key: 0,
  class: "error-no-record mt-3"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("span", null, "No Record Found")
], -1)
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-md-4" }
const _hoisted_47 = { class: "col-md-4" }
const _hoisted_48 = { class: "col-md-4" }
const _hoisted_49 = { class: "row mb-2" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, null, -1)
const _hoisted_51 = { class: "d-flex col-md-6" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_54 = {
  key: 0,
  class: "error-no-record"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("span", null, "No Record Found")
], -1)
const _hoisted_56 = { class: "row mb-1 text-left" }
const _hoisted_57 = { class: "col-md-12" }
const _hoisted_58 = {
  for: "advanceSearchShowBoth",
  class: "ml-2"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-1 text-left" }, [
  /*#__PURE__*/_createElementVNode("label", null, "To show items containing the following text:")
], -1)
const _hoisted_60 = { class: "row mb-2" }
const _hoisted_61 = { class: "col-md-4" }
const _hoisted_62 = {
  key: 0,
  class: "col-md-1 text-center align-self-center"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", null, "AND", -1)
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = {
  key: 1,
  class: "col-md-1 text-center align-self-center"
}
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", null, "OR", -1)
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = { class: "col-md-4" }
const _hoisted_69 = { class: "col-md-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheSidebar = _resolveComponent("TheSidebar")!
  const _component_ThePageLoading = _resolveComponent("ThePageLoading")!
  const _component_ThePageHeader = _resolveComponent("ThePageHeader")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_TheLoading = _resolveComponent("TheLoading")!
  const _component_ThePageError = _resolveComponent("ThePageError")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TheSidebar),
            (_ctx.isPageLoading)
              ? (_openBlock(), _createBlock(_component_ThePageLoading, {
                  key: 0,
                  pageTitle: ''
                }))
              : _createCommentVNode("", true),
            (!_ctx.isPageLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_ThePageHeader, {
                    pageTitle: _ctx.pageError != '' ? '' : '[' + this.journalEntity.journal.consoGroupName + '] ' + this.journalEntity.id
                  }, null, 8, ["pageTitle"]),
                  (_ctx.pageError == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _hoisted_9,
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_InputText, {
                                class: "journal-entity-cell",
                                modelValue: _ctx.journalEntity.id,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.journalEntity.id) = $event)),
                                maxlength: "50",
                                placeholder: "Journal ID",
                                disabled: _ctx.journalEntity.journal.status == 'Consolidated'
                              }, null, 8, ["modelValue", "disabled"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_Calendar, {
                                class: "journal-entity-cell",
                                dateFormat: "yy-mm-dd",
                                manualInput: true,
                                placeholder: "Date",
                                modelValue: _ctx.journalEntity.date,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.journalEntity.date) = $event)),
                                disabled: _ctx.journalEntity.journal.status == 'Consolidated'
                              }, null, 8, ["modelValue", "disabled"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _hoisted_15,
                            _createElementVNode("div", _hoisted_16, [
                              _createVNode(_component_Dropdown, {
                                class: "journal-entity-cell",
                                options: _ctx.companies,
                                optionLabel: "code",
                                filter: "",
                                showClear: "",
                                placeholder: _ctx.isCompanyLoading ? ('Loading...') : '-- Please Select --',
                                loading: _ctx.isCompanyLoading,
                                modelValue: _ctx.journalEntity.company,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.journalEntity.company) = $event)),
                                autoOptionFocus: true,
                                filterFields: ['code', 'name'],
                                disabled: _ctx.journalEntity.journal.status == 'Consolidated'
                              }, {
                                value: _withCtx((slotProps) => [
                                  (slotProps.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                        _createElementVNode("span", _hoisted_18, _toDisplayString(slotProps.value.code), 1),
                                        _createElementVNode("span", _hoisted_19, _toDisplayString(slotProps.value.name), 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(slotProps.placeholder), 1))
                                ]),
                                option: _withCtx((slotProps) => [
                                  _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("span", _hoisted_22, _toDisplayString(slotProps.option.code), 1),
                                    _createElementVNode("span", _hoisted_23, _toDisplayString(slotProps.option.name), 1)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["options", "placeholder", "loading", "modelValue", "disabled"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _hoisted_25,
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_InputText, {
                                class: "journal-entity-cell",
                                modelValue: _ctx.journalEntity.description,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.journalEntity.description) = $event)),
                                maxlength: "255",
                                placeholder: "Description",
                                disabled: _ctx.journalEntity.journal.status == 'Consolidated'
                              }, null, 8, ["modelValue", "disabled"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _hoisted_28,
                            _createElementVNode("div", _hoisted_29, [
                              _createVNode(_component_Textarea, {
                                modelValue: _ctx.journalEntity.remarks,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.journalEntity.remarks) = $event)),
                                rows: "2",
                                cols: "50",
                                placeholder: "Remarks",
                                disabled: _ctx.journalEntity.journal.status == 'Consolidated'
                              }, null, 8, ["modelValue", "disabled"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(_component_Divider)
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _hoisted_32,
                            _createElementVNode("div", _hoisted_33, [
                              _createVNode(_component_Dropdown, {
                                class: "journal-entity-cell",
                                virtualScrollerOptions: { itemSize: 50 },
                                options: _ctx.accounts,
                                filter: "",
                                showClear: "",
                                placeholder: "-- Please Select --",
                                modelValue: _ctx.account,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.account) = $event)),
                                filterFields: ['code', 'description'],
                                resetFilterOnHide: true,
                                disabled: _ctx.journalEntity.journal.status == 'Consolidated'
                              }, {
                                value: _withCtx((slotProps) => [
                                  (slotProps.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                        _createElementVNode("span", _hoisted_35, _toDisplayString(slotProps.value.code), 1),
                                        _createElementVNode("span", _hoisted_36, _toDisplayString(slotProps.value.description != null ?  slotProps.value.description : ''), 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(slotProps.placeholder), 1))
                                ]),
                                option: _withCtx((slotProps) => [
                                  _createElementVNode("div", _hoisted_38, [
                                    _createElementVNode("span", _hoisted_39, _toDisplayString(slotProps.option.code), 1),
                                    _createElementVNode("span", _hoisted_40, _toDisplayString(slotProps.option.description != null ?  slotProps.option.description : ''), 1)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["options", "modelValue", "disabled"])
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                              _createVNode(_component_Button, {
                                class: "journal-entity-cell mr-2",
                                icon: "pi pi-plus",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addAccount(false))),
                                disabled: _ctx.account == null || _ctx.journalEntity.journal.status == 'Consolidated'
                              }, null, 8, ["disabled"]),
                              _createVNode(_component_Button, {
                                class: "journal-entity-cell mr-2",
                                icon: "pi pi-search",
                                onClick: _ctx.openAdvancedSearchDialog,
                                severity: "warning",
                                label: "Advanced",
                                disabled: _ctx.journalEntity.journal.status == 'Consolidated'
                              }, null, 8, ["onClick", "disabled"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _createVNode(_component_DataTable, {
                              class: "journal-table",
                              value: _ctx.journalEntity.journalEntityAccounts,
                              responsiveLayout: "scroll",
                              selectionMode: "single",
                              paginator: "",
                              paginatorPosition: "bottom",
                              rows: 20
                            }, _createSlots({
                              empty: _withCtx(() => [
                                (_ctx.journalEntity.journalEntityAccounts.length <= 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                      _createVNode(_component_FontAwesomeIcon, {
                                        icon: ['fas', 'image'],
                                        size: "2x"
                                      }),
                                      _hoisted_44
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_Column, {
                                  style: {"width":"10%"},
                                  field: "accountCode",
                                  header: "Code"
                                }),
                                _createVNode(_component_Column, {
                                  style: {"width":"50%"},
                                  header: "Description"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createTextVNode(_toDisplayString(slotProps.data.accountDescription != null ? slotProps.data.accountDescription : ''), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  style: {"width":"15%"},
                                  field: "accountDr",
                                  header: "DR"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      class: "journal-entity-cell number",
                                      modelValue: slotProps.data.accountDr,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.accountDr) = $event),
                                      mode: "decimal",
                                      maxFractionDigits: 0,
                                      disabled: _ctx.journalEntity.journal.status == 'Consolidated'
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  style: {"width":"15%"},
                                  field: "accountCr",
                                  header: "CR"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      class: "journal-entity-cell number",
                                      modelValue: slotProps.data.accountCr,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.accountCr) = $event),
                                      mode: "decimal",
                                      maxFractionDigits: 0,
                                      disabled: _ctx.journalEntity.journal.status == 'Consolidated'
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  style: {"width":"10%"},
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_Button, {
                                      icon: "pi pi-trash",
                                      severity: "danger",
                                      text: "",
                                      rounded: "",
                                      onClick: ($event: any) => (_ctx.removeAccount(slotProps.index)),
                                      title: "Remove",
                                      disabled: _ctx.journalEntity.journal.status == 'Consolidated',
                                      hidden: _ctx.isViewer
                                    }, null, 8, ["onClick", "disabled", "hidden"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, [
                              (_ctx.journalEntity.journalEntityAccounts.length > 0)
                                ? {
                                    name: "footer",
                                    fn: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_45, [
                                        _createElementVNode("div", _hoisted_46, [
                                          _createElementVNode("span", null, "Total Debit: " + _toDisplayString(_ctx.totalDebit.toLocaleString()), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_47, [
                                          _createElementVNode("span", null, "Total Credit: " + _toDisplayString(_ctx.totalCredit.toLocaleString()), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_48, [
                                          _createElementVNode("span", {
                                            style: _normalizeStyle(_ctx.totalDifference != 0 ? 'color:red' : '')
                                          }, "Difference: " + _toDisplayString(_ctx.totalDifference.toLocaleString()), 5)
                                        ])
                                      ])
                                    ]),
                                    key: "0"
                                  }
                                : undefined
                            ]), 1032, ["value"])
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            _hoisted_50,
                            _createElementVNode("div", _hoisted_51, [
                              _createVNode(_component_Button, {
                                class: "p-button-sm",
                                disabled: _ctx.v$.journalEntity.$invalid || _ctx.isLoading || _ctx.totalDifference!=0 || _ctx.journalEntity.journal.status == 'Consolidated',
                                hidden: _ctx.isViewer,
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.entityId == null ? _ctx.save() : _ctx.update())),
                                label: "Save"
                              }, null, 8, ["disabled", "hidden"]),
                              _hoisted_52,
                              _createVNode(_component_Button, {
                                class: "p-button-sm p-button-secondary",
                                onClick: _ctx.cancel,
                                label: "Cancel"
                              }, null, 8, ["onClick"]),
                              _hoisted_53,
                              (_ctx.isLoading)
                                ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.pageError != '')
                    ? (_openBlock(), _createBlock(_component_ThePageError, {
                        key: 1,
                        onBackEvent: _ctx.cancel,
                        pageError: _ctx.pageError
                      }, null, 8, ["onBackEvent", "pageError"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_TheFooter)
          ])
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      class: "advanced-search-dialog",
      visible: _ctx.advanceSearchDialog.visible,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.advanceSearchDialog.visible) = $event)),
      modal: "",
      draggable: false,
      header: "Advanced Search",
      style: {"width":"55vw","height":"75vh"},
      onHide: _ctx.closeAdvancedSearchDialog
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _createVNode(_component_Checkbox, {
              modelValue: _ctx.advanceSearchDialog.isShowBoth,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.advanceSearchDialog.isShowBoth) = $event)),
              inputId: "advanceSearchShowBoth",
              binary: true,
              onChange: _ctx.filterAccount
            }, null, 8, ["modelValue", "onChange"]),
            _createElementVNode("label", _hoisted_58, " Showing items containing '" + _toDisplayString(_ctx.advanceSearchDialog.filterA) + "' and '" + _toDisplayString(_ctx.advanceSearchDialog.filterB) + "' ", 1)
          ])
        ]),
        _hoisted_59,
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _createVNode(_component_InputText, {
              modelValue: _ctx.advanceSearchDialog.filterA,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.advanceSearchDialog.filterA) = $event)),
              onKeyup: _ctx.filterAccount
            }, null, 8, ["modelValue", "onKeyup"])
          ]),
          (_ctx.advanceSearchDialog.isShowBoth)
            ? (_openBlock(), _createElementBlock("div", _hoisted_62, _hoisted_64))
            : (_openBlock(), _createElementBlock("div", _hoisted_65, _hoisted_67)),
          _createElementVNode("div", _hoisted_68, [
            _createVNode(_component_InputText, {
              modelValue: _ctx.advanceSearchDialog.filterB,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.advanceSearchDialog.filterB) = $event)),
              onKeyup: _ctx.filterAccount
            }, null, 8, ["modelValue", "onKeyup"])
          ]),
          _createElementVNode("div", _hoisted_69, [
            _createVNode(_component_Button, {
              icon: "pi pi-plus",
              label: "Add",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.addAccount(true))),
              disabled: _ctx.account == null
            }, null, 8, ["disabled"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DataTable, {
          paginator: "",
          first: 0,
          rows: 10,
          selection: _ctx.account,
          "onUpdate:selection": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.account) = $event)),
          value: _ctx.filteredAccount,
          dataKey: "identifier",
          onPage: _ctx.resetScroll,
          onRowClick: _ctx.selectAccount,
          rowClass: ()=>'clickable'
        }, {
          empty: _withCtx(() => [
            (_ctx.filteredAccount.length <= 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _createVNode(_component_FontAwesomeIcon, {
                    icon: ['fas', 'image'],
                    size: "2x"
                  }),
                  _hoisted_55
                ]))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              style: {"width":"15%"},
              field: "code",
              header: "Code"
            }),
            _createVNode(_component_Column, { header: "Description" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.description != null ? slotProps.data.description : ''), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["selection", "value", "onPage", "onRowClick", "rowClass"])
      ]),
      _: 1
    }, 8, ["visible", "onHide"])
  ], 64))
}